import axios from 'axios'
import { createEmailWithTemplate } from '../../platform/notifications/email/factory/emailFactory'
import { sendEmail } from '../../third-party/mailgun/services/mailgunService'
import { attemptAddLead } from "../../platform/notifications/leads/services/leadService"
import { createLead } from "../../platform/notifications/leads/factory/leadFactory"
import {getProphetApi, getServerApi} from '../../config/deployment'
import { getAnyFirebaseToken } from '@/platform/auth/services/authService.js'
import { performRequest_PUT, performRequest_POST } from '../../platform/utils/http/httpService'

import { ingressResponseTo, ingressSalesResponseTo, ingressDummyTo } from '../tranformer/import/pricingTransformer'

const KEY = "zjeWjvGbdi4j7R1QxWCxYzTxLKhvRS"
const URI = getProphetApi()
const REPOR_URI = getServerApi() + "/api/prophet/report"

export const createPriceRequestReport=async(report)=>{
  try{
    var headers = { "Authorization": await getAnyFirebaseToken() };
    var resp = await performRequest_POST(REPOR_URI, report, headers)
    if(resp.success) return resp.response.data.body
    else return false
  }catch(ex){
    console.log("createPriceRequestReport | ex: ", ex)
    return false
  }
}

export const updatePriceRequestReport=async(reportId, updates)=>{
  try{
    var headers = { "Authorization": await getAnyFirebaseToken() };
    const data = {
      reportId: reportId,
      updates: updates
    }
    var resp = await performRequest_PUT(REPOR_URI, data, headers)
    if(resp.success) return resp.response.data.body
    else return false
  }catch(ex){
    console.log("updatePriceRequestReport | ex: ", ex)
    return false
  }
}

export const getRentPrediction = async (request) => {
  // return ingressDummyTo()
  const response = await getPricePrediction(URI + "/rent", request)
  return ingressResponseTo(response)
}

export const getSalePrediction = async (request) => {
  const response = await getPricePrediction(URI + "/sale", request)
  return ingressSalesResponseTo(response)
}

const getPricePrediction=(uri, request)=>{
  return new Promise((resolve, reject) => {
    var config = {
      params: request,
      headers: { Authorization: KEY }
    }

    axios.get(uri, config)
      .then(resp => {
        if (resp.data) resolve(resp.data)
        else reject("no response")
      })
      .catch(err => {
        reject(err)
      })
    // Use for testing
    // resolve(ingressResponseTo(dummyResponse))
  })
}

export const attemptToSendPricePredictionOnEmail = (predictionsResponse, toEmail, propertyAddress, visitorType, isRent, similarProperties, lableCompany) => {
  let priceDesc = "Your rental estimate for one month at "
  if(!isRent) priceDesc = "You property valuation at "

  let similarProperty4, similarProperty4Link, similarProperty3, similarProperty3Link, similarProperty2, similarProperty2Link, similarProperty1, similarProperty1Link
  if(similarProperties){
    for (let i = 0; i < similarProperties.length; i++) {
      const property = similarProperties[i];
      if(i === 0){
        similarProperty1 = property.street_name + " " + property.street_number + " priced at " + property.rent
        similarProperty1Link = property.url
      }
      else if(i === 1){
        similarProperty2 = property.street_name + " " + property.street_number + " priced at " + property.rent
        similarProperty2Link = property.url
      }
      else if(i === 2){
        similarProperty3 = property.street_name + " " + property.street_number + " priced at " + property.rent
        similarProperty3Link = property.url
      }
      else if(i === 3){
        similarProperty4 = property.street_name + " " + property.street_number + " priced at " + property.rent
        similarProperty4Link = property.url
      }
    }
  }

  const variables = {
    monthy_rent_price_prediction: predictionsResponse.price.toFixed(2) + "€",
    price_descrption: priceDesc,
    property_address: propertyAddress,
    time_period: "month",
    similar_property_1: similarProperty1,
    similar_property_1_link: similarProperty1Link,
    similar_property_2: similarProperty2,
    similar_property_2_link: similarProperty2Link,
    similar_property_3: similarProperty3,
    similar_property_3_link: similarProperty3Link,
    similar_property_4: similarProperty4,
    similar_property_4_link: similarProperty4Link
  }

  console.log("variables: ", variables)

  let template = "property_valuation_report"
  if(lableCompany === "uusmaa")template = "property_valuation_report_uusmaa"

  const emailCommand = createEmailWithTemplate(
    "Moowle <info@moowle.com>",
    toEmail,
    "Your Property Valuation by Moowle", 
    template,
    variables
  )

  attemptAddLead(createLead({ email: toEmail, vars: { type: visitorType } }))
  sendEmail(emailCommand)
    .catch(err => {
      console.log("attemptToSendPricePredictionOnEmail | err:", err)
    })

}


const dummyResponse = {
  "apartmentData": {
      "nr_of_rooms": 2,
      "total_area": 53.0,
      "has_balcony": 1,
      "has_parking": 1,
      "room_size": "41-54.99",
      "first_floor": 0,
      "last_floor": 0,
      "middle_floor": 1,
      "brand new": 1,
      "all new": 1,
      "renovated": 0,
      "good condition": 0,
      "needs renovating": 0,
      "development": 0,
      "no description": 0,
      "county": "Harju maakond",
      "district": "Haabersti linnaosa",
      "lat": 59.43221349999999,
      "lng": 24.6859362,
      "district_rent_class": "medium",
      "district_rent_price_median": 390.0
  },
  "rentPricePrediction": 553.9816824895179,
  "similiarApartments": [
      {
          "district": "Haabersti linnaosa",
          "street_name": "Pikaliiva tn",
          "street_number": "22",
          "lat": 59.419713029243205,
          "lng": 24.6315509893842,
          "built_year": 2020.0,
          "total_area": 52.2,
          "nr_of_rooms": 2,
          "has_balcony": 1,
          "has_parking": 1,
          "first_floor": 0,
          "middle_floor": 1,
          "last_floor": 0,
          "all new": 0,
          "brand new": 1,
          "good condition": 0,
          "needs renovating": 0,
          "no description": 0,
          "renovated": 0,
          "room_size": "41-54.99",
          "district_rent_class": "medium",
          "district_rent_price_median": 390.0,
          "url": "https://www.city24.ee/en/real-estate/apartments-for-rent/Tallinn-Haabersti-linnaosa/4067829",
          "rent": 575
      },
      {
          "district": "Haabersti linnaosa",
          "street_name": "Vanakuu tn",
          "street_number": "1",
          "lat": 59.429630133039396,
          "lng": 24.6187665661434,
          "built_year": 2018.0,
          "total_area": 49.0,
          "nr_of_rooms": 2,
          "has_balcony": 1,
          "has_parking": 1,
          "first_floor": 0,
          "middle_floor": 1,
          "last_floor": 0,
          "all new": 0,
          "brand new": 1,
          "good condition": 0,
          "needs renovating": 0,
          "no description": 0,
          "renovated": 0,
          "room_size": "41-54.99",
          "district_rent_class": "medium",
          "district_rent_price_median": 390.0,
          "url": "https://www.city24.ee/en/real-estate/apartments-for-rent/Tallinn-Haabersti-linnaosa/4063921",
          "rent": 600
      },
      {
          "district": "Haabersti linnaosa",
          "street_name": "Noorkuu tn",
          "street_number": "2",
          "lat": 59.42982005770761,
          "lng": 24.6203733556556,
          "built_year": 2019.0,
          "total_area": 51.3,
          "nr_of_rooms": 2,
          "has_balcony": 1,
          "has_parking": 1,
          "first_floor": 1,
          "middle_floor": 0,
          "last_floor": 0,
          "all new": 0,
          "brand new": 1,
          "good condition": 0,
          "needs renovating": 0,
          "no description": 0,
          "renovated": 0,
          "room_size": "41-54.99",
          "district_rent_class": "medium",
          "district_rent_price_median": 390.0,
          "url": "https://www.city24.ee/en/real-estate/apartments-for-rent/Tallinn-Haabersti-linnaosa/4920485",
          "rent": 550
      },
      {
          "district": "Haabersti linnaosa",
          "street_name": "Moonalao",
          "street_number": "7",
          "lat": 59.402062686421004,
          "lng": 24.6149404894348,
          "built_year": 2018.0,
          "total_area": 45.9,
          "nr_of_rooms": 2,
          "has_balcony": 0,
          "has_parking": 1,
          "first_floor": 0,
          "middle_floor": 1,
          "last_floor": 0,
          "all new": 0,
          "brand new": 1,
          "good condition": 0,
          "needs renovating": 0,
          "no description": 0,
          "renovated": 0,
          "room_size": "41-54.99",
          "district_rent_class": "medium",
          "district_rent_price_median": 390.0,
          "url": "https://www.kv.ee/anda-uurile-hubane-sisustatud-2toaline-korter-uues-3273153.html?nr=1346",
          "rent": 520
      },
      {
          "district": "Haabersti linnaosa",
          "street_name": "Astangu tn",
          "street_number": "19/1",
          "lat": 59.4055040398689,
          "lng": 24.6275559579069,
          "built_year": 2017.0,
          "total_area": 48.8,
          "nr_of_rooms": 2,
          "has_balcony": 1,
          "has_parking": 1,
          "first_floor": 1,
          "middle_floor": 0,
          "last_floor": 0,
          "all new": 0,
          "brand new": 1,
          "good condition": 0,
          "needs renovating": 0,
          "no description": 0,
          "renovated": 0,
          "room_size": "41-54.99",
          "district_rent_class": "medium",
          "district_rent_price_median": 390.0,
          "url": "https://www.kv.ee/uurile-anda-mobleeritud-2toaline-avara-planeeringu-2965965.html?nr=14853",
          "rent": 490
      }
  ]
}


// WEBPACK FOOTER //
// ./src/pricing/services/pricingService.js